import { useEffect, useState } from 'react'
import { logError } from 'lib/logging'

export type LocationItem = {
  id: string
  name: string
}

export type UsePmsSchedulesReturn = {
  locations: LocationItem[]
}

export function usePmsSchedules(): UsePmsSchedulesReturn {
  const [locations, setLocations] = useState<LocationItem[]>([])

  useEffect(() => {
    fetch(`/api/pms-schedules/locations`, { credentials: `include` })
      .then((res) => res.json())
      .then((d) => {
        const locs = (d.locations ?? []).map((loc: { id?: string; name?: string }) => ({
          id: loc.id!,
          name: loc.name ?? '',
        }))
        setLocations(locs)
      })
      .catch((err) => logError(`Error fetching PMS schedules locations`, err))
  }, [])

  return { locations }
}
